module.exports = __webpack_public_path__ + "img/clothing-store.1e7f36cd.png";